import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";
import PlatformPage from "@/pages/PlatformPage";
import OrderPage from "@/pages/OrderPage";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import TrackPage from "@/pages/TrackPage";
import ChatWidget from "@/components/ChatWidget";

function ScrollReset() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.__lenis?.resize();
    window.__lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <ScrollReset />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services/:slug" element={<PlatformPage />} />
          <Route path="/order/:lookupKey" element={<OrderPage />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/track" element={<TrackPage />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
        <ChatWidget />
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
